/** @graphql cc **/

import gql from 'graphql-tag';

export const DatabaseReferenceModalCurrentUserQuery = gql`
	query DatabaseReferenceModalCurrentUserQuery {
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
			emails {
				value
				isPrimary
			}
			locale
		}
	}
`;
